const brandToken = {
  50: '#0043CE',
  100: '#0043CE',
  200: '#0043CE',
  500: '#0043CE', //'#166055',
};

const lightToken = {
  50: '#FFFFFF',
  100: '#413B74', // secondary-900 //'#F6F7F7'
  200: '#EDEDED',
  300: '#8D8D8D',
};

const darkToken = {
  50: '#1A1B1C',
  100: '#6D659D', //secondary-700 '#131415',
  200: '#313233',
  300: '#AAAAAA',
};

const light = {
  ...lightToken,

  // todo Update this once we move to the same brand color throughout the app
  border: lightToken[200],
  background: 'white',
  highlight: brandToken[50],
  hover: lightToken[100],

  'text-primary': darkToken[100],
  'text-secondary': lightToken[300],

  'primary-button': brandToken[100],
  'primary-button-active': brandToken[200],
};

const dark = {
  ...darkToken,

  border: darkToken[200],
  background: darkToken[100],
  highlight: brandToken[50],
  hover: darkToken[200],

  'text-primary': lightToken[50],
  'text-secondary': darkToken[300],

  'primary-button': brandToken[100],
  'primary-button-active': brandToken[200],
};

const atsColors = {
  'ats-primary': '#605AFB',
  'ats-secondary': '#FFFFFF',
  'ats-tertiary': '#F4F4FB',
  'ats-bg-primary': '#F7F7F7',
  'ats-bg-secondary': 'linear-gradient(180deg, #1B194D 0%, #121133 100%)',
  'ats-bg-tertiary': 'rgba(90, 84, 255, 0.12)',
  'ats-border-color': '#EAEAEA',
  'ats-bg-hover':
    'linear-gradient(266.98deg, #F4F4FB 2.51%, rgba(244, 244, 251, 0) 97.49%)',
  'ats-text-primary': '#0E0C0F',
  'ats-text-secondary': '#464547',
  'ats-text-tertiary': '#636363',
  'ats-negative': '#A32020',
  'color-light': '4A4A4A',
  'color-dark': 'FFFFFF',
  'color-danger': '#FF5454',
  'ats-text-light': '#7E7E7E',
  'ats-text-dark': '#222222',
  'hover-light': '#FAFBFD',
  'border-light': '#D9D9D9',
  'pending-border': '#D78E00',
  'border-color-header': '#E4E5FA',
  'modal-header-footer-border': '#E9EBF4',
};

const newColors = {
  // Base colors
  'base-black': '#131122',
  'base-white': '#FFF',

  // Primary colors
  'primary-25': '#F5F6FF',
  'primary-50': '#EDF0FF',
  'primary-100': '#DEE4FF',
  'primary-200': '#C3CCFF',
  'primary-300': '#9FAAFF',
  'primary-400': '#797DFF',
  'primary-500': '#605AFB',
  'primary-600': '#503BF0',
  'primary-700': '#442ED4',
  'primary-800': '#3828AB',
  'primary-900': '#322887',
  'primary-950': '#1E184E',

  // gray colors
  'secondary-25': '#F8F9FC',
  'secondary-50': '#F3F4F9',
  'secondary-100': '#E9EBF4',
  'secondary-200': '#D7DAEB',
  'secondary-300': '#BFC3DF',
  'secondary-400': '#A6A7D2',
  'secondary-500': '#9998BD',
  'secondary-600': '#847EAD',
  'secondary-700': '#6D659D',
  'secondary-800': '#585281',
  'secondary-900': '#413B74',
  'secondary-950': '#262244',

  // Status colors
  'status-1': '#DC3636',
  'status-2': '#FF8769',
  'status-3': '#FAA238',
  'status-4': '#4FD08A',

  // Priority colors
  'priority-critical': '#F15D07',
  'priority-important': '#FB9256',

  // Pastel colors
  'pastel-1-light': '#FFEBE5',
  'pastel-1-dark': '#CC2900',
  'pastel-2-light': '#E3F7EB',
  'pastel-2-dark': '#227743',
  'pastel-3-light': '#F0E7FE',
  // Hover fill for the automation lightning chip — lighter than
  // `pastel-3-light`, so the chip lifts rather than deepens.
  'pastel-3-lightest': '#F9F5FF',
  'pastel-3-dark': '#680AF5',
  'pastel-4-light': '#EAF4FA',
  'pastel-4-dark': '#1E587B',
  'pastel-5-light': '#F3F4F9',
  'pastel-5-dark': '#585281',
  'pastel-6-light': '#FEEACD',
  'pastel-6-dark': '#4D0F00',
  'pastel-7-light': '#E3F2FD',
  'pastel-7-dark': '#0D47A1',
  'pastel-8-light': '#FCE4EC',
  'pastel-8-dark': '#880E4F',
  'pastel-9-light': '#FFFDE7',
  'pastel-9-dark': '#7A6000',
  'pastel-10-light': '#FDF6E3',
  'pastel-10-dark': '#B58900',
  'pastel-11-light': '#FAF0FA',
  'pastel-11-dark': '#960D96',

  'warning-100': '#F4C790',
  'warning-200': '#EDA145',
  'warning-300': '#CC7914',
  'error-25': '#F392A2',
  'error-100': '#E4626F',
  'error-200': '#C03744',
  'error-300': '#8C1823',
  // The design-token error family only spans 25→300, but components across the
  // app reference Chakra-style 500/600/700 names. Alias them so those usages
  // actually render red: 500 → the vivid red (matches 200), 600/700 → the dark
  // red (matches 300). Keep in sync with tailwind.config.js.
  'error-500': '#C03744',
  'error-600': '#8C1823',
  'error-700': '#8C1823',
  'success-100': '#A4F4E7',
  'success-200': '#15B097',
  'success-300': '#0B7B69',

  //border colors
  'border-color': '#E9EBF4',
  'border-color1': '#EFECF0',
};

export const colors = {
  brand: brandToken,
  light,
  dark,
  ...atsColors,
  ...newColors,
};
